import {ACCOUNTS_INSTANCE, EVENTCHAIN_INSTANCE, PASS_ORDER_INSTANCE, PLACES_INSTANCE} from "@/helper/consts";

import Breadcrumbs from "@/modules/responsible/Breadcrumbs";
import names from "@/modules/responsible/routers/names";
import OrdersBreadcrumbs from "@/modules/responsible/orders/OrdersBreadcrumbs";
import OrdersDetail from "../orders/pages/Detail"


export default ([
    {
        path: "/responsible",
        name: names.MAIN,
        component: Breadcrumbs,
        meta: {
            breadcrumb: "Работник",
            requiredAuth: true,
            instances: [
                PASS_ORDER_INSTANCE,
                ACCOUNTS_INSTANCE,
                EVENTCHAIN_INSTANCE
            ]
        },
        children: [
            {
                path: "orders",
                name: names.ORDERS.LIST,
                component: OrdersBreadcrumbs,
                meta: {
                    breadcrumb: "Заявки",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idOrders",
                        name: names.ORDERS.DETAIL,
                        component: OrdersDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            }
        ]
    }
])
